import Vue from 'vue'
import Vuex from 'vuex'
import { DateTime, Duration } from 'luxon'
import { gameEventTypes, blindLevelTypes, rebuysAllowed, topupsAllowed, numberWithCommas, sounds, playSound, userStatus, seasonObjectTypes, whatIsIt, clearArray, userSignInProvider, signInProvider, isInUse } from '../constants'
import router from '../router'
import database from './Db_CloudFirestore'
import { auth, presenceDB, isOfflineForPresenceDB, isOnlineForPresenceDB, storage, fieldValue } from '../config'

Vue.use(Vuex)

auth.onAuthStateChanged(user => {
  if (!router.currentRoute.meta.hasOwnProperty('requiresAuth') || router.currentRoute.meta.requiresAuth) {
    store.commit('setLoading', {component: 'seasons', val: true})
    if (user) {
      store.dispatch('initializeUserData', user).then(() => {
        if (!router.currentRoute.path.toLowerCase().startsWith('/home')) {
          router.push('/home')
        }
      }).catch(function (err) {
        store.dispatch('displayError', err.message)
        store.dispatch('clearData')
      })
    } else {
      store.dispatch('clearData')
    }
  }
})

export const store = new Vuex.Store({
  state: {
    notify: [],
    currentUser: {
      displayName: '',
      email: '',
      emailVerified: false,
      uid: '',
      photoURL: '',
      providerId: signInProvider.unknown,
      new: false,
      premium: false
    },
    seasons: [],
    shared: {
      readers: {},
      owners: {},
      seasons: [],
      active: false
    },
    seasonPlayers: [],
    seasonSchedules: [],
    seasonGames: [],
    seasonStats: {},
    loading: {
      seasons: true,
      players: false,
      profile: true,
      eventTimer: true,
      eventTimerResetPending: false
    },
    onSnapshots: {},
    activeGameId: -1,
    activeSeasonId: -1,
    gameTimerEvents: [],
    gameTimerPlayers: [],
    gameTimerGame: {},
    gameTimer: {
      state: -1,
      playTime: Duration.fromMillis(0),
      timeRemaining: '00:00',
      blindCurrentIndex: -1,
      blindCurrent: ' / ',
      blindPrevious: 'Start',
      blindNext: ' / ',
      blindMessage: null,
      playButton: true,
      rwdButton: false,
      fwdButton: true,
      updateTimer: null,
      playersKOd: 0,
      totalPot: 0,
      payouts: [],
      duringFirstBreak: false,
      duringSecondBreak: false,
      firstBreakFinished: false,
      secondBreakFinished: false,
      canRebuy: false,
      canTopup: false,
      isFinished: false,
      isFirstLevel: true,
      isLastLevel: false,
      totalChips: 0,
      totalChipsFormatted: '',
      averageChips: '',
      rolloverSent: false
    },
    gameTimerWarningPlayed: {
      five: false,
      three: false,
      one: false
    },
    serverTimeOffset: 0
  },
  getters: {
    getUser: state => {
      return state.currentUser
    },
    isPremium: state => {
      return state.currentUser.premium
    },
    playerById: (state) => (id) => {
      let array = state.seasonPlayers
      for (var i = 0; i < array.length; i++) {
        if (array[i]['id'] === id) {
          return array[i]
        }
      }
      return null
    },
    /* seasonById: (state) => (id) => {
      let array = state.seasons
      for (var i = 0; i < array.length; i++) {
        if (array[i]['id'] === id) {
          return array[i]
        }
      }
      return null
    }, */
    currentSeason: (state) => {
      if (state.activeSeasonId !== -1) {
        let array = []
        if (!state.shared.active) {
          array = state.seasons
        } else {
          array = state.shared.seasons
        }
        let id = state.activeSeasonId

        for (var i = 0; i < array.length; i++) {
          if (array[i]['id'] === id) {
            return array[i]
          }
        }
        return null
      } else {
        return null
      }
    },
    scheduleById: (state) => (id) => {
      let array = state.seasonSchedules
      for (var i = 0; i < array.length; i++) {
        if (array[i]['id'] === id) {
          return array[i]
        }
      }
      return null
    },
    gameById: (state) => (id) => {
      let array = state.seasonGames
      for (var i = 0; i < array.length; i++) {
        if (array[i]['id'] === id) {
          return array[i]
        }
      }
      return null
    },
    gameTimerGameBroadcast: (state) => {
      if (state.gameTimerGame.hasOwnProperty('b')) {
        return state.gameTimerGame.b
      } else {
        return ''
      }
    },
    blindByLevel: (state) => (level) => {
      let blind = ''
      if (level.hasOwnProperty('t')) {
        switch (level.t) {
          case blindLevelTypes.blind:
            blind = numberWithCommas(level.s) + ' / ' + numberWithCommas(level.b)
            break
          case blindLevelTypes.break:
            blind = 'BREAK'
            break
          default:
            break
        }
      }
      return blind
    },
    gameTimerActivePlayers: (state) => (playerId = null) => {
      let activePlayers = []
      for (let index = 0; index < state.gameTimerPlayers.length; index++) {
        const player = state.gameTimerPlayers[index]
        if (player.isStillIn && player.id !== playerId) {
          activePlayers.push(player)
        }
      }
      return activePlayers
    },
    gameTimerPlayerById: (state) => (id) => {
      let array = state.gameTimerPlayers
      for (var i = 0; i < array.length; i++) {
        if (array[i]['id'] === id) {
          return array[i]
        }
      }
      return null
    },
    activeSeasonName: (state) => {
      let seasonId = state.activeSeasonId
      let seasonName = 'None'
      switch (seasonId) {
        case -2:
          seasonName = 'New'
          break
        case -3:
          seasonName = 'Importing'
          break
        case -1:
          seasonName = 'None'
          break
        default:
          let array = []
          if (!state.shared.active) {
            array = state.seasons
          } else {
            array = state.shared.seasons
          }
          for (var i = 0; i < array.length; i++) {
            if (array[i]['id'] === seasonId) {
              seasonName = array[i].n
            }
          }
          if (state.shared.active) {
            seasonName = 'Shared: ' + seasonName
          }
          break
      }
      return seasonName
    },
    activeGameName: (state) => {
      let gameId = state.activeGameId
      if (gameId !== -1 && state.gameTimerGame.hasOwnProperty('d')) {
        return state.gameTimerGame.d
      }
      return 'None'
    },
    nextNotification: (state) => {
      if (state.notify.length > 0) {
        return state.notify[state.notify.length - 1]
      } else {
        return null
      }
    }
  },
  mutations: {
    setCurrentUser (state) {
      let user = auth.currentUser
      let newSessionKey = presenceDB.ref('/status/' + user.uid).push().key
      let userStatusPresenceDBRef = presenceDB.ref('/status/' + user.uid + '/' + newSessionKey)

      /* Create a reference to the special '.info/connected' path in
       Realtime Database. This path returns `true` when connected
       and `false` when disconnected. */
      presenceDB.ref('.info/connected').on('value', function (snapshot) {
        // If we're not currently connected, don't do anything.
        if (snapshot.val() === false) {
          database.user.setStatus(user.uid, userStatus.offline).catch(err => {
            store.dispatch('displayError', err.message)
          })
          return
        }
        /* If we are currently connected, then use the 'onDisconnect()'
        method to add a set which will only trigger once this
        client has disconnected by closing the app,
        losing internet, or any other means. */
        userStatusPresenceDBRef.onDisconnect().update(isOfflineForPresenceDB).then(function () {
          /* The promise returned from .onDisconnect().set() will
          resolve as soon as the server acknowledges the onDisconnect()
          request, NOT once we've actually disconnected:
          https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

          We can now safely set ourselves as 'online' knowing that the
          server will mark us as offline once we lose connection. */
          userStatusPresenceDBRef.update(isOnlineForPresenceDB)

          // We'll also add Firestore set here for when we come online.
          database.user.setStatus(user.uid, userStatus.online).catch(err => {
            store.dispatch('displayError', err.message)
          })
        })
      })
      if (user !== null) {
        state.currentUser.displayName = user.displayName
        state.currentUser.email = user.email
        state.currentUser.emailVerified = user.emailVerified
        state.currentUser.uid = user.uid
        state.currentUser.photoURL = user.photoURL
        userSignInProvider(user).then(provider => {
          state.currentUser.providerId = provider
        })
      } else {
        state.currentUser.displayName = ''
        state.currentUser.email = ''
        state.currentUser.emailVerified = false
        state.currentUser.uid = ''
        state.currentUser.photoURL = ''
        state.currentUser.providerId = signInProvider.unknown
        state.currentUser.new = false
      }
    },
    setCurrentUserPremium (state) {
      state.currentUser.premium = true
    },
    setNewUser (state) {
      state.currentUser.new = true
    },
    refreshCurrentUser (state) {
      let user = auth.currentUser
      state.currentUser.displayName = user.displayName
      state.currentUser.email = user.email
      state.currentUser.emailVerified = user.emailVerified
      state.currentUser.photoURL = user.photoURL
      state.currentUser.new = false
    },
    setSharedOwners (state, val) {
      state.shared.owners = val
    },
    setSharedReaders (state, val) {
      state.shared.readers = val
    },
    clearCurrentUser (state) {
      state.currentUser.displayName = ''
      state.currentUser.email = ''
      state.currentUser.emailVerified = false
      state.currentUser.uid = ''
      state.currentUser.photoURL = ''
      state.currentUser.providerId = signInProvider.unknown
      state.currentUser.new = false
      state.premium = false
    },
    clearActiveSeason (state) {
      clearArray(state.seasonGames)
      clearArray(state.seasonPlayers)
      clearArray(state.seasonSchedules)
      for (var property in state.seasonStats) delete state.seasonStats[property]
    },
    clearSeasons (state) {
      clearArray(state.seasons)
      for (let property in state.shared.readers) delete state.shared.readers[property]
      for (let property in state.shared.owners) delete state.shared.owners[property]
      clearArray(state.shared.seasons)
      state.shared.active = false
    },
    setSeasons (state, val) {
      state.seasons = val
      state.loading.seasons = false
    },
    setSharedSeasons (state, val) {
      state.shared.seasons = val
    },
    setSeasonPlayers (state, val) {
      state.seasonPlayers = val
    },
    setSeasonSchedules (state, val) {
      state.seasonSchedules = val
    },
    setSeasonStats (state, val) {
      state.seasonStats = val
    },
    setSeasonGames (state, val) {
      state.seasonGames = val
    },
    setLoading (state, val) {
      state.loading[val.component] = val.val
    },
    stopSnapshot (state, val) {
      try {
        state.onSnapshots[val]()
        delete state.onSnapshots[val]
      } catch (error) {}
    },
    setActiveSeasonId (state, { seasonId, shared = false }) {
      state.activeSeasonId = seasonId
      state.shared.active = shared
    },
    setActiveGameId (state, val) {
      state.activeGameId = val
    },
    setGameTimerGame (state, val) {
      Object.keys(state.gameTimerGame).forEach(key => {
        if (!val.hasOwnProperty(key)) {
          val[key] = state.gameTimerGame[key]
        }
      })
      state.gameTimerGame = val
    },
    setGameTimerSchedule (state, val) {
      state.gameTimerGame.schedule = val
    },
    setGameTimerLevels (state, val) {
      state.gameTimerGame.schedule.levels = val
    },
    setGameTimerState (state, gameEvent) {
      let eventType = gameEvent.e
      let eventTime = DateTime.fromISO(gameEvent.t).minus(state.serverTimeOffset)
      switch (eventType) {
        case gameEventTypes.created:
          state.gameTimer.state = eventType
          state.gameTimer.stateTime = eventTime
          state.gameTimer.playTime = Duration.fromMillis(0)
          break
        case gameEventTypes.pause:
          if (state.gameTimer.state === gameEventTypes.play) {
            state.gameTimer.playTime = state.gameTimer.playTime.plus(eventTime.diff(state.gameTimer.stateTime))
          }
          state.gameTimer.state = eventType
          state.gameTimer.stateTime = eventTime
          break
        case gameEventTypes.finished:
          store.commit('stopGameTimerUpdateTimer')
          if (state.gameTimer.state === gameEventTypes.play) {
            state.gameTimer.playTime = state.gameTimer.playTime.plus(eventTime.diff(state.gameTimer.stateTime))
          }
          state.gameTimer.state = eventType
          state.gameTimer.stateTime = eventTime
          state.gameTimer.isFinished = true
          break
        case gameEventTypes.next:
        case gameEventTypes.previous:
          let timePassedDuration = Duration.fromMillis(0)
          let resetDuration = Duration.fromMillis(0)
          let durationSinceEvent = eventTime.diff(state.gameTimer.stateTime)
          let index = 0
          let levels = state.gameTimerGame.schedule.levels
          let previousLevel = false
          switch (state.gameTimer.state) {
            case gameEventTypes.created:
              break
            case gameEventTypes.play:
              store.commit('stopGameTimerUpdateTimer')
              let playTime = state.gameTimer.playTime
              timePassedDuration = durationSinceEvent.plus(playTime)
              break
            case gameEventTypes.pause:
              timePassedDuration = state.gameTimer.playTime
              break
            case gameEventTypes.previous:
            case gameEventTypes.next:
              timePassedDuration = state.gameTimer.playTime
              previousLevel = true
              break
            default:
              break
          }

          while (index < levels.length && timePassedDuration.as('minutes') >= levels[index].m) {
            timePassedDuration = timePassedDuration.minus(Duration.fromObject({minutes: levels[index].m}))
            resetDuration = resetDuration.plus(Duration.fromObject({minutes: levels[index].m}))
            index += 1
          }
          if (eventType === gameEventTypes.previous) {
            if (previousLevel || index === levels.length) {
              if (index > 0) {
                state.gameTimer.playTime = resetDuration.minus(Duration.fromObject({minutes: levels[index - 1].m}))
              } else {
                state.gameTimer.playTime = resetDuration
              }
            } else {
              state.gameTimer.playTime = resetDuration
            }
          } else {
            if (index === levels.length) {
              state.gameTimer.playTime = resetDuration
            } else {
              state.gameTimer.playTime = resetDuration.plus(Duration.fromObject({minutes: levels[index].m}))
            }
          }
          state.gameTimer.state = eventType
          state.gameTimer.stateTime = eventTime
          break
        default:
          state.gameTimer.state = eventType
          state.gameTimer.stateTime = eventTime
          break
      }
    },
    updateGameTimer (state, gameTimer) {
      Object.keys(gameTimer).forEach(function (key) {
        if (gameTimer[key] !== state.gameTimer[key]) {
          state.gameTimer[key] = gameTimer[key]
        }
      })
    },
    updateGameTimerUpdateTimer (state, val) {
      state.gameTimer.updateTimer = val
    },
    stopGameTimerUpdateTimer (state, val) {
      if (state.gameTimer.updateTimer !== null) {
        clearInterval(state.gameTimer.updateTimer)
      }
      state.gameTimer.updateTimer = null
    },
    resetGameTimerEvents (state) {
      state.loading.eventTimerResetPending = true
    },
    addGameTimerEvent (state, gameEvent) {
      state.gameTimerEvents.push(gameEvent)
    },
    setGameTimerEvents (state, val) {
      state.gameTimerEvents = val
    },
    setGameTimerFinished (state, val) {
      state.gameTimer.isFinished = val
    },
    clearGameTimer (state, val) {
      state.loading.eventTimer = true
      state.loading.eventTimerResetPending = false
      clearArray(state.gameTimerPlayers)
      clearArray(state.gameTimerEvents)
      for (var property in state.gameTimerGame) delete state.gameTimerGame[property]
      state.gameTimer.state = -1
      state.gameTimer.playTime = Duration.fromMillis(0)
      state.gameTimer.timeRemaining = '00:00'
      state.gameTimer.blindCurrentIndex = -1
      state.gameTimer.blindCurrent = ' / '
      state.gameTimer.blindPrevious = 'Start'
      state.gameTimer.blindNext = ' / '
      state.gameTimer.blindMessage = null
      state.gameTimer.playButton = true
      state.gameTimer.rwdButton = false
      state.gameTimer.fwdButton = true
      state.gameTimer.updateTimer = null
      state.gameTimer.playersKOd = 0
      state.gameTimer.totalPot = 0
      state.gameTimer.duringFirstBreak = false
      state.gameTimer.duringSecondBreak = false
      state.gameTimer.firstBreakFinished = false
      state.gameTimer.secondBreakFinished = false
      state.gameTimer.canRebuy = false
      state.gameTimer.canTopup = false
      state.gameTimer.isFinished = false
      state.gameTimer.isFirstLevel = true
      state.gameTimer.isLastLevel = false
      state.gameTimer.totalChips = 0
      state.gameTimer.totalChipsFormatted = ''
      state.gameTimer.averageChips = ''
      state.gameTimer.rolloverSent = false
      clearArray(state.gameTimer.payouts)
      state.gameTimerWarningPlayed.five = false
      state.gameTimerWarningPlayed.three = false
      state.gameTimerWarningPlayed.one = false
    },
    knockoutPlayer (state, event) {
      let KOData = event.d
      let playerKOdBy = {}
      state.gameTimerPlayers.forEach(player => {
        if (player.id === KOData.i1) {
          if (KOData.r) {
            player.rebuys += 1
          } else {
            player.stillIn = false
            player.place = state.gameTimerPlayers.length - state.gameTimer.playersKOd
            state.gameTimer.playersKOd = state.gameTimer.playersKOd + 1
            player.points = state.gameTimer.playersKOd - player.rebuys - player.topups
            if (player.points < 0) {
              player.points = 0
            }
          }
        } else if (player.id === KOData.i2) {
          player.KOs += 1
          playerKOdBy = player
        }
      })
      if (state.gameTimer.playersKOd === (state.gameTimerPlayers.length - 1)) {
        playerKOdBy.stillIn = false
        playerKOdBy.place = 1
        playerKOdBy.points = state.gameTimerPlayers.length - playerKOdBy.rebuys - playerKOdBy.topups
        if (playerKOdBy.points < 0) {
          playerKOdBy.points = 0
        }
      }
      store.commit('sortGameTimerPlayers')
      store.commit('setTotalPotandChips')
    },
    topupPlayer (state, event) {
      let topupData = event.d
      state.gameTimerPlayers.forEach(player => {
        if (player.id === topupData.i1) {
          player.topups += 1
        }
      })
      store.commit('setTotalPotandChips')
    },
    setGameTimerPlayers (state, players) {
      state.gameTimerPlayers = players
    },
    sortGameTimerPlayers (state) {
      state.gameTimerPlayers.sort(function (a, b) {
        var nameA = a.n.toUpperCase()
        var nameB = b.n.toUpperCase()

        var stillInA = a.stillIn
        var stillInB = b.stillIn

        var placeA = a.place
        var placeB = b.place

        if (stillInA && !stillInB) {
          return -1
        }
        if (stillInB && !stillInA) {
          return 1
        }
        if (!stillInA && placeA > placeB) {
          return 1
        }
        if (!stillInA && placeB > placeA) {
          return -1
        }

        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
    },
    setTotalPotandChips (state) {
      let totalPot = 0
      let totalChips = 0
      for (let index = 0; index < state.gameTimerPlayers.length; index++) {
        const player = state.gameTimerPlayers[index]
        totalPot += state.gameTimerGame.schedule.bt - state.gameTimerGame.schedule.by
        totalChips += state.gameTimerGame.schedule.bc
        totalPot += (state.gameTimerGame.schedule.rt - state.gameTimerGame.schedule.ry) * player.rebuys
        totalChips += state.gameTimerGame.schedule.rc * player.rebuys
        totalPot += (state.gameTimerGame.schedule.tt - state.gameTimerGame.schedule.ty) * player.topups
        totalChips += state.gameTimerGame.schedule.tc * player.topups
      }
      state.gameTimer.totalPot = totalPot
      state.gameTimer.totalChips = totalChips
    },
    setGameTimerWarningPlayed (state, val) {
      Object.keys(state.gameTimerWarningPlayed).forEach(key => {
        if (!val.hasOwnProperty(key)) {
          val[key] = state.gameTimerWarningPlayed[key]
        }
      })
      state.gameTimerWarningPlayed = val
    },
    setServerTimeOffset (state, val) {
      state.serverTimeOffset = val
    },
    addNotification (state, { message, duration, isError = false }) {
      if (message.trim() !== '' && duration > 0) {
        let notification = {
          message: message,
          duration: duration,
          isError: isError
        }
        state.notify.unshift(notification)
      }
    },
    removeNotification (state) {
      if (state.notify.length > 0) {
        state.notify.pop()
      }
    },
    setGameTimerRolloverSent (state, val) {
      if (val) {
        state.gameTimer.rolloverSent = true
      } else {
        state.gameTimer.rolloverSent = false
      }
    }
  },
  actions: {
    async clearData ({commit}) {
      await store.dispatch('clearActiveSeason')
      await store.dispatch('stopSnapshot', 'seasons')
      await store.dispatch('stopSnapshot', 'sharedSeasons')
      commit('clearSeasons')
      commit('clearCurrentUser')
    },
    setSeasons ({commit, state}, seasons) {
      commit('setSeasons', seasons)
    },
    setSharedSeasons ({ commit, state }, seasons) {
      commit('setSharedSeasons', seasons)
    },
    setSharedOwners ({ commit }, owners) {
      commit('setSharedOwners', owners)
    },
    setSharedReaders ({ commit }, readers) {
      commit('setSharedReaders', readers)
    },
    setSeasonPlayers ({commit, state}, players) {
      commit('setSeasonPlayers', players)
    },
    setSeasonSchedules ({commit, state}, schedules) {
      commit('setSeasonSchedules', schedules)
    },
    deleteSeasonReader ({ commit, state }, { readerId, seasonId }) {
      return new Promise((resolve, reject) => {
        if (readerId !== state.currentUser.uid) {
          database.season.deleteReader(readerId, seasonId).then(wasRemoved => {
            resolve(wasRemoved)
          }).catch(err => {
            reject(Error('Error deleting reader: ' + err.message))
          })
        } else {
          reject(Error('Error deleting reader: Unable to modify permissions granted to you.'))
        }
      })
    },
    addSeasonReader ({ commit, state }, { readerId, seasonId }) {
      return new Promise((resolve, reject) => {
        if (readerId !== state.currentUser.uid) {
          database.season.addReader(readerId, seasonId).then(() => {
            resolve()
          }).catch(err => {
            reject(Error('Error adding reader: ' + err.message))
          })
        } else {
          reject(Error('Error adding reader: Unable to modify permissions granted to you.'))
        }
      })
    },
    async setSeasonStatistics ({commit, state, getters}, seasonStats) {
      let stats = {}
      let players = {}
      let KOs = []
      let rebuys = 0
      let topups = 0
      let totalPot = 0
      let tempPlayerPoints = {}
      let currentSeason = getters.currentSeason

      for (let index = 0; index < state.seasonPlayers.length; index++) {
        let player = state.seasonPlayers[index]
        let statPlayer = {}
        statPlayer.name = player.n
        statPlayer.rebuys = 0
        statPlayer.topups = 0
        statPlayer.KOs = 0
        statPlayer.finishes = []
        statPlayer.points = 0
        statPlayer.handicap = player.h
        statPlayer.yearEnd = player.y
        for (let index = 0; index < state.seasonPlayers.length; index++) {
          statPlayer.finishes.push(0)
        }
        players[player.id] = statPlayer
      }
      for (let index = 0; index < seasonStats.length; index++) {
        let statGame = seasonStats[index]
        rebuys += statGame.r
        topups += statGame.t
        statGame.k.forEach(knockout => {
          knockout.gameId = statGame.gameId
          KOs.push(knockout)
        })
        let currentSchedule = getters.scheduleById(getters.gameById(statGame.gameId).s)
        let statGameKeys = Object.keys(statGame.p)

        for (let i = 0; i < statGameKeys.length; i++) {
          const playerId = statGameKeys[i]
          if (players.hasOwnProperty(playerId)) {
            let player = statGame.p[playerId]
            if (players[playerId].yearEnd) {
              totalPot += currentSchedule.by
              totalPot += currentSchedule.ty * player.t
              totalPot += currentSchedule.ry * player.r
            }
            players[playerId].topups += player.t
            players[playerId].rebuys += player.r
            players[playerId].KOs += player.k
            players[playerId].finishes[player.f] += 1
            let statPoints = {}
            statPoints.gameId = statGame.gameId
            statPoints.points = player.p
            statPoints.doesCount = false
            if (!tempPlayerPoints.hasOwnProperty(playerId)) {
              tempPlayerPoints[playerId] = []
            }
            tempPlayerPoints[playerId].push(statPoints)
          }
        }
      }
      let tempPlayerPointsKeys = Object.keys(tempPlayerPoints)
      for (let index = 0; index < tempPlayerPointsKeys.length; index++) {
        const playerId = tempPlayerPointsKeys[index]
        let player = tempPlayerPoints[playerId].sort(function (a, b) {
          return b.points - a.points
        })

        for (let index = 0; index < player.length; index++) {
          const stat = player[index]
          if (index < currentSeason.m) {
            players[playerId].points += stat.points
            stat.doesCount = true
          }
          let gameId = stat.gameId
          delete stat.gameId
          players[playerId][gameId] = stat
        }
      }
      stats.payouts = []
      switch (currentSeason.spo) {
        case 1:
          stats.payouts.push(totalPot)
          break
        case 2:
          stats.payouts.push(Math.round(totalPot * 0.6))
          stats.payouts.push(totalPot - stats.payouts[0])
          break
        case 3:
          stats.payouts.push(Math.round(totalPot * 0.5))
          stats.payouts.push(Math.round(totalPot * 0.3))
          stats.payouts.push(totalPot - stats.payouts[0] - stats.payouts[1])
          break
      }
      stats.totalPot = totalPot
      stats.players = players
      stats.KOs = KOs
      stats.rebuys = rebuys
      stats.topups = topups
      commit('setSeasonStats', stats)
    },
    setSeasonGames ({commit, state}, games) {
      commit('setSeasonGames', games)
    },
    setLoading ({commit, state}, val) {
      commit('setLoading', val)
    },
    clearActiveSeason ({commit}) {
      store.dispatch('clearActiveGame')
      store.dispatch('stopSnapshot', 'seasonPlayers')
      store.dispatch('stopSnapshot', 'seasonSchedules')
      store.dispatch('stopSnapshot', 'seasonGames')
      store.dispatch('stopSnapshot', 'seasonStats')
      commit('clearActiveSeason')
      commit('setActiveSeasonId', { seasonId: -1 })
    },
    initializeUserData ({commit, state}, user) {
      return new Promise((resolve, reject) => {
        database.user.get(user.uid).then(async legacyUser => {
          let userUpdate = {}
          if (!legacyUser.hasOwnProperty('name') || legacyUser.name !== user.displayName) {
            userUpdate.new = true
            userUpdate.name = user.displayName
          }
          if (!legacyUser.hasOwnProperty('photoURL') || legacyUser.photoURL !== user.photoURL) {
            userUpdate.photoURL = user.photoURL
          }
          if (legacyUser.premium) {
            store.commit('setCurrentUserPremium')
          }
          if (userUpdate !== {}) {
            await database.user.update(user.uid, userUpdate).catch(err => {
              let newError = Error('Legacy profile error: ' + err.message)
              reject(newError)
            })
          }
          store.dispatch('currentServerTimeOffset').then(() => {
            store.commit('setCurrentUser')
            if (legacyUser.hasOwnProperty('new') || userUpdate.hasOwnProperty('new')) {
              commit('setNewUser')
            }
            store.dispatch('startSnapshot', { 'name': 'seasons', 'collection': 'seasons' })
            store.dispatch('startSnapshot', { 'name': 'sharedSeasons', 'collection': 'sharedSeasons' })
            resolve()
          })
        }).catch(err => {
          reject(Error('Error initializing user data:' + err.message))
        })
      })
    },
    searchByUsername ({commit}, searchString) {
      return new Promise((resolve, reject) => {
        database.user.search(searchString).then(users => {
          resolve(users)
        }).catch(err => {
          reject(Error('Error searching for user:' + err.message))
        })
      })
    },
    addSeasonPlayer ({commit, state, getters}, {seasonId, player}) {
      return new Promise((resolve, reject) => {
        store.dispatch('seasonIncreaseMaxId', {seasonId: seasonId, type: seasonObjectTypes.player}).then(function (playerId) {
          database.season.addPlayer(state.currentUser.uid, seasonId, playerId, player).then(() => {
            resolve(playerId)
          }).catch(err => {
            reject(Error('Error adding new player:' + err.message))
          })
        }).catch(err => {
          reject(Error('Error adding new player:' + err.message))
        })
      })
    },
    seasonIncreaseMaxId ({commit, state, getters}, {seasonId, type, scheduleId, gameId, eventType}) {
      return new Promise((resolve, reject) => {
        database.season.incrementMaxId(state.currentUser.uid, seasonId, type, scheduleId, gameId, eventType).then(newId => {
          resolve(newId)
        }).catch(err => {
          reject(Error('Error incrementing max Id: ' + err.message))
        })
      })
    },
    editSeasonPlayer ({commit, state}, {seasonId, player}) {
      return new Promise((resolve, reject) => {
        let playerId = player.id
        delete player.id
        database.season.updatePlayer(state.currentUser.uid, seasonId, playerId, player).then(playerId => {
          resolve(playerId)
        }).catch(err => {
          reject(Error('Error editing season player: ' + err.message))
        })
      })
    },
    deleteSeasonPlayer ({commit, state}, {seasonId, playerId}) {
      return new Promise((resolve, reject) => {
        database.season.deletePlayer(state.currentUser.uid, seasonId, playerId).then(() => {
          resolve()
        }).catch(err => {
          reject(Error('Error deleting season player: ' + err.message))
        })
      })
    },
    seasonStatisticsDelete ({state}, {seasonId, statisticId}) {
      return new Promise((resolve, reject) => {
        database.season.deleteStatistics(state.currentUser.uid, seasonId, statisticId).then(() => {
          resolve()
        }).catch(err => {
          reject(Error('Error deleting season statistic: ' + err.message))
        })
      })
    },
    deleteGameEvent ({commit, state}, {seasonId, gameId, eventId, broadcast = ''}) {
      return new Promise((resolve, reject) => {
        database.game.deleteEvent(state.currentUser.uid, seasonId, gameId, eventId, broadcast).then(eventId => {
          store.dispatch('gameEventAdd', {seasonId: seasonId, gameId: gameId, type: gameEventTypes.delete, eventId: eventId, broadcast: broadcast}).then(() => {
            resolve(eventId)
          }).catch(err => {
            reject(new Error('Event deleted, but delete not broadcasted.  Please refresh all timers. /n' + err.message))
          })
        }).catch(err => {
          reject(new Error('Error deleting event. Please try again./n' + err.message))
        })
      })
    },
    startSnapshot ({commit, state}, val) {
      if (state.onSnapshots.hasOwnProperty(val.name)) {
        commit('stopSnapshot', val.name)
      }
      switch (val.collection) {
        case 'seasons':
          database.season.createSnapshot(state.currentUser.uid).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting seasons snapshot: ' + err.message)
          })
          break
        case 'sharedSeasons':
          database.season.createSharedSnapshot(state.currentUser.uid).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting shared seasons snapshot: ' + err.message)
          })
          break
        case 'seasonPlayers':
          database.season.createPlayersSnapshot(state.currentUser.uid, state.activeSeasonId).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting seasonPlayers snapshot: ' + err.message)
          })
          break
        case 'seasonSchedules':
          database.season.createSchedulesSnapshot(state.currentUser.uid, state.activeSeasonId).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting seasonSchedules snapshot: ' + err.message)
          })
          break
        case 'seasonStats':
          database.season.createStatsSnapshot(state.currentUser.uid, state.activeSeasonId).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting seasonStats snapshot: ' + err.message)
          })
          break
        case 'seasonGames':
          database.season.createGamesSnapshot(state.currentUser.uid, state.activeSeasonId).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting seasonGames snapshot: ' + err.message)
          })
          break
        case 'gameTimerEvents':
          commit('setGameTimerEvents', [])
          database.game.createEventsSnapshot(state.currentUser.uid, state.activeSeasonId, state.activeGameId).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting gameEvents snapshot: ' + err.message)
          })
          break
        case 'gameTimerGame':
          database.game.createTimerGameSnapshot(state.currentUser.uid, state.activeSeasonId, state.activeGameId).then(snapshot => {
            state.onSnapshots[val.name] = snapshot
          }).catch(err => {
            store.dispatch('displayError', 'Error starting gameTimerGame snapshot: ' + err.message)
          })
          break
        default:
          break
      }
    },
    stopSnapshot ({commit}, val) {
      commit('stopSnapshot', val)
    },
    gameTimerSnapshotChange ({ commit, state }, data) {
      commit('setGameTimerGame', data)
    },
    async gameEventSnapshotChange ({commit, state}, docChanges) {
      commit('setLoading', { component: 'eventTimer', val: true })
      let eventAdded = false
      for (let i = 0; i < docChanges.length; i++) {
        const change = docChanges[i]
        let gameEvent = {}
        switch (change.type) {
          case 'added':
            gameEvent = { seasonId: state.activeSeasonId, gameId: state.activeGameId, doc: change.doc.data() }
            gameEvent.doc.id = change.doc.id
            await store.dispatch('gameEventAdded', gameEvent).catch(function (err) {
              store.dispatch('displayError', 'Error adding gameEvent:' + err.message)
            })
            eventAdded = true
            break
          case 'modified':
            gameEvent = change.doc.data()
            break
          default:
            break
        }
      }
      commit('setLoading', { component: 'eventTimer', val: false })
      if (state.gameTimer.playersKOd === (state.gameTimerPlayers.length - 1) && !state.gameTimer.isFinished && !state.shared.active) {
        await store.dispatch('gameEventAdd', { type: gameEventTypes.finished, gameId: state.activeGameId, seasonId: state.activeSeasonId, broadcast: state.gameTimerGame.b })
      }
      if (eventAdded) {
        await store.dispatch('refreshGameTimer')
      }
      if (state.loading.eventTimerResetPending) {
        store.dispatch('gameActivate', state.activeGameId)
      }
    },
    currentServerTimeOffset: ({commit, state}) => {
      return new Promise((resolve, reject) => {
        var offsetRef = presenceDB.ref('.info/serverTimeOffset')
        offsetRef.on('value', function (snap) {
          var offset = snap.val()
          commit('setServerTimeOffset', offset)
          resolve()
        })
      })
    },
    getScheduleLevels ({commit, state}, scheduleId) {
      return new Promise((resolve, reject) => {
        database.season.getScheduleLevels(state.currentUser.uid, state.activeSeasonId, scheduleId).then(levels => {
          resolve(levels)
        }).catch(err => {
          reject(new Error('Error getting schedule levels: ' + err.message))
        })
      })
    },
    seasonScheduleUpdated ({commit, state, getters}, seasonScheduleUpdates) {
      return new Promise(async (resolve, reject) => {
        var scheduleId = seasonScheduleUpdates.scheduleId

        // scheduleUpdated: this.scheduleInfoTemp.updates
        let scheduleUpdated = seasonScheduleUpdates.scheduleUpdated
        if (scheduleId !== -1) {
          await database.season.updateSchedule(state.currentUser.uid, state.activeSeasonId, scheduleId, scheduleUpdated).catch(err => {
            reject(new Error('Error updating schedule: ' + err.message))
          })
        } else {
          await store.dispatch('seasonIncreaseMaxId', {seasonId: state.activeSeasonId, type: seasonObjectTypes.schedule}).then(async function (newId) {
            scheduleId = newId
            scheduleUpdated.l = -1
            await database.season.updateSchedule(state.currentUser.uid, state.activeSeasonId, scheduleId, scheduleUpdated).catch(err => {
              reject(new Error('Error creating schedule: ' + err.message))
            })
          }).catch(err => {
            reject(new Error('Error creating schedule: ' + err.message))
          })
        }

        database.season.updateScheduleLevels(state.currentUser.uid, state.activeSeasonId, scheduleId, seasonScheduleUpdates).then(() => {
          resolve()
        }).catch(err => {
          reject(new Error('Error updating schedule levels: ' + err.message))
        })
      })
    },
    seasonScheduleDelete ({commit, state}, {scheduleId, seasonId = -1}) {
      return new Promise((resolve, reject) => {
        if (seasonId === -1) {
          seasonId = state.activeSeasonId
        }
        database.season.deleteSchedule(state.currentUser.uid, seasonId, scheduleId).then(() => {
          resolve()
        }).catch(err => {
          reject(new Error('Error deleting schedule: ' + err.message))
        })
      })
    },
    async seasonDelete ({commit, state}, seasonId) {
      return new Promise((resolve, reject) => {
        if (state.activeSeasonId === seasonId) {
          store.dispatch('stopSnapshot', 'seasonPlayers')
          store.dispatch('stopSnapshot', 'seasonSchedules')
          store.dispatch('stopSnapshot', 'seasonGames')
          commit('setActiveSeasonId', { seasonId: -1 })
        }
        database.season.delete(state.currentUser.uid, seasonId).then(seasonUndoDoc => {
          resolve(seasonUndoDoc)
        }).catch(seasonUndoDoc => {
          reject(seasonUndoDoc.err)
        })
      })
    },
    seasonGameUpdate ({commit, state}, {seasonId, game, initialEvent = true}) {
      return new Promise((resolve, reject) => {
        var gameId = game.id
        delete game.id

        if (gameId !== -1) {
          database.season.updateGame(state.currentUser.uid, seasonId, gameId, game).then(() => {
            resolve()
          }).catch(err => {
            reject(new Error('Game update failed: ' + err.message))
          })
        } else {
          store.dispatch('seasonIncreaseMaxId', { seasonId: seasonId, type: seasonObjectTypes.game }).then(newId => {
            gameId = newId
            game.e = -1
            database.season.updateGame(state.currentUser.uid, seasonId, gameId, game).then(() => {
              if (initialEvent) {
                let gameEvent = { type: gameEventTypes.created, gameId: gameId, seasonId: state.activeSeasonId, order: 0, broadcast: game.b }
                // console.log('First Event for New Game', gameEvent)
                store.dispatch('gameEventAdd', gameEvent).then(() => {
                  resolve(gameId)
                }).catch(err => {
                  reject(new Error('Game creation failed: ' + err.message))
                })
              } else {
                resolve(gameId)
              }
            }).catch(err => {
              reject(new Error('Game creation failed: ' + err.message))
            })
          })
        }
      })
    },
    async seasonGameDelete ({commit, state}, {gameId, seasonId = -1}) {
      return new Promise((resolve, reject) => {
        if (seasonId === -1) {
          seasonId = state.activeSeasonId
        }
        database.season.deleteGame(state.currentUser.uid, seasonId, gameId).then(gameUndoDoc => {
          resolve(gameUndoDoc)
        }).catch(eventUndoErr => {
          let gameUndoDoc = null
          if (eventUndoErr.hasOwnProperty('err')) {
            let err = eventUndoErr.err
            delete eventUndoErr.err
            gameUndoDoc.events = eventUndoErr
            gameUndoDoc.err = err
          } else {
            gameUndoDoc.events = []
            gameUndoDoc.err = eventUndoErr
          }
          reject(gameUndoDoc)
        })
      })
    },
    gameEventAdd ({commit, state}, {seasonId, gameId, type, order = null, playerId1, playerId2, rebuy, eventId, broadcast = ''}) {
      return new Promise(async (resolve, reject) => {
        var gameEvent = {}
        var eventSource = -1
        if (type !== gameEventTypes.loading) {
          switch (type) {
            case gameEventTypes.created:
              eventSource = seasonObjectTypes.event
              break
            case gameEventTypes.rollover:
              eventSource = seasonObjectTypes.event
              break
            case gameEventTypes.knockout:
              eventSource = seasonObjectTypes.timerEvent
              gameEvent.d = { i1: playerId1, i2: playerId2, r: rebuy }
              break
            case gameEventTypes.topup:
              eventSource = seasonObjectTypes.timerEvent
              gameEvent.d = { i1: playerId1 }
              break
            case gameEventTypes.delete:
              eventSource = seasonObjectTypes.timerEvent
              gameEvent.d = { i1: eventId }
              break
            case gameEventTypes.finished:
              eventSource = seasonObjectTypes.timerEvent
              let gameStat = {}
              let players = {}
              let KOs = []
              let rebuys = 0
              let topups = 0
              for (let index = 0; index < state.gameTimerPlayers.length; index++) {
                const player = state.gameTimerPlayers[index]
                let newStat = {}
                newStat.k = player.KOs
                newStat.f = player.place
                newStat.r = player.rebuys
                rebuys += player.rebuys
                newStat.t = player.topups
                topups += player.topups
                newStat.p = player.points
                players[player.id] = newStat
              }
              for (let index = 0; index < state.gameTimerEvents.length; index++) {
                const event = state.gameTimerEvents[index]
                if (event.e === gameEventTypes.knockout) {
                  let ko = {}
                  ko.i1 = event.d.i1
                  ko.i2 = event.d.i2
                  ko.r = event.d.r
                  ko.t = event.t
                  KOs.push(ko)
                }
              }
              gameStat.p = players
              gameStat.k = KOs
              gameStat.t = topups
              gameStat.r = rebuys
              await database.game.createStat(state.currentUser.uid, seasonId, gameId, gameStat).catch(err => {
                reject(new Error('Game event creation failed: ' + err.message))
              })
              break
            default:
              eventSource = seasonObjectTypes.timerEvent
              break
          }
          gameEvent.e = type
          if (order !== null) {
            gameEvent.o = order
          } else {
            gameEvent.o = state.gameTimerEvents.length
          }
          gameEvent.t = DateTime.local().plus(state.serverTimeOffset).toJSON()
          store.dispatch('seasonIncreaseMaxId', { seasonId: seasonId, type: eventSource, gameId: gameId, eventType: type, broadcast: broadcast }).then(eventId => {
            database.game.createEvent(state.currentUser.uid, seasonId, gameId, eventId, gameEvent, broadcast).then(() => {
              resolve()
            }).catch(err => {
              reject(new Error('Game event creation failed: ' + err.message))
            })
          }).catch(err => {
            reject(new Error('Game event creation failed: ' + err.message))
          })
        }
        resolve()
      })
    },
    eventImport ({commit, state}, {seasonId, gameId, event}) {
      return new Promise(async (resolve, reject) => {
        let eventSource = seasonObjectTypes.event
        store.dispatch('seasonIncreaseMaxId', { seasonId: seasonId, type: eventSource, gameId: gameId, eventType: event.e }).then(eventId => {
          database.game.createEvent(state.currentUser.uid, seasonId, gameId, eventId, event).then(() => {
            resolve()
          }).catch(err => {
            reject(new Error('Game event creation failed: ' + err.message))
          })
        }).catch(err => {
          reject(new Error('Game event creation failed: ' + err.message))
        })
      })
    },
    seasonUpdate ({commit, state}, season) {
      return new Promise((resolve, reject) => {
        var seasonId = season.id
        delete season.id
        if (!(seasonId < 0)) {
          database.season.update(state.currentUser.uid, seasonId, season).then(() => {
            resolve()
          }).catch(function (err) {
            reject(new Error('Season Update failed: ' + err.message))
          })
        } else {
          season.g = -1 // Last Game Id
          season.s = -1 // Last Schedule Id
          season.p = -1 // Last Player Id
          database.season.create(state.currentUser.uid, season).then(seasonId => {
            store.dispatch('seasonActivate', { seasonId: seasonId }).then(() => {
              resolve(seasonId)
            })
          }).catch(function (err) {
            reject(new Error('Season Creation failed: ' + err.message))
          })
        }
      })
    },
    getPreviousVersionSeasonList ({commit, state}) {
      return new Promise((resolve, reject) => {
        database.season.getPreviousVersionList(state.currentUser.uid).then(seasons => {
          resolve(seasons)
        }).catch(function (err) {
          reject(new Error('Getting previous version season list failed: ' + err.message))
        })
      })
    },
    importSeasonPreviousVersion ({commit, state}, seasonId) {
      return new Promise((resolve, reject) => {
        database.season.jsonify(seasonId, state.currentUser.uid, true).then(previousVersionJSON => {
          store.dispatch('importSeason', previousVersionJSON).then(newSeasonId => {
            store.dispatch('seasonActivate', { seasonId: newSeasonId }).then(() => {
              resolve()
            })
          }).catch(function (err) {
            reject(new Error('Season import failed: ' + err.message))
          })
        }).catch(function (err) {
          reject(new Error('Reading previous version season failed: ' + err.message))
        })
      })
    },
    importSeason ({commit, state}, seasonJSON) {
      return new Promise((resolve, reject) => {
        if (
          whatIsIt(seasonJSON) === 'Object' || !seasonJSON.hasOwnProperty('n') ||
          !seasonJSON.hasOwnProperty('gpo') || !seasonJSON.hasOwnProperty('spo') ||
          !seasonJSON.hasOwnProperty('r') || !seasonJSON.hasOwnProperty('t') ||
          !seasonJSON.hasOwnProperty('m')
        ) {
          let newSeason = {}
          let scheduleIdLookup = {}
          let playerIdLookup = {}
          let gameIdLookup = {}
          if (seasonJSON.n !== '') {
            newSeason.n = 'Import of ' + seasonJSON.n
          } else {
            console.log('Empty season name (n) not allowed.')
            reject(new Error('Empty season name (n) not allowed.'))
            return
          }
          if (seasonJSON.gpo < 1 || seasonJSON.gpo > 3) {
            console.log('Season Games Paid Places (gpo) needs to be between 1 and 3.')
            reject(new Error('Season Games Paid Places (gpo) needs to be between 1 and 3.'))
            return
          }
          newSeason.gpo = seasonJSON.gpo
          if (seasonJSON.spo < 1 || seasonJSON.spo > 3) {
            console.log('Season Paid Places (spo) needs to be between 1 and 3.')
            reject(new Error('Season Paid Places (spo) needs to be between 1 and 3.'))
            return
          }
          newSeason.spo = seasonJSON.spo
          if (!(Object.values(rebuysAllowed).includes(seasonJSON.r))) {
            console.log('Season Rebuys Allowed (r) not a recognized value.')
            reject(new Error('Season Rebuys Allowed (r) not a recognized value.'))
            return
          }
          newSeason.r = seasonJSON.r
          if (!(Object.values(topupsAllowed).includes(seasonJSON.t))) {
            console.log('Season Topups Allowed (t) not a recognized value.')
            reject(new Error('Season Topups Allowed (t) not a recognized value.'))
            return
          }
          newSeason.t = seasonJSON.t
          newSeason.m = parseInt(seasonJSON.m)
          if (isNaN(newSeason.m) || newSeason.m <= 0) {
            console.log('Season Max Games (m) not a recognized value.')
            reject(new Error('Season Max Games (m) not a recognized value.'))
            return
          }
          newSeason.g = -1 // Last Game Id
          newSeason.s = -1 // Last Schedule Id
          newSeason.p = -1 // Last Player Id
          database.season.create(state.currentUser.uid, newSeason).then(async seasonId => {
            if (seasonJSON.hasOwnProperty('schedules')) {
              for (let i = 0; i < seasonJSON.schedules.length; i++) {
                const schedule = seasonJSON.schedules[i]
                let oldScheduleId = schedule.id
                await store.dispatch('importNewSchedule', { 'seasonId': seasonId, 'schedule': schedule }).then(scheduleId => {
                  scheduleIdLookup[oldScheduleId] = scheduleId
                })
              }
            }
            if (seasonJSON.hasOwnProperty('players')) {
              // import players, keeping map of old to new player id's
              for (let i = 0; i < seasonJSON.players.length; i++) {
                const player = seasonJSON.players[i]
                let newPlayer = {}
                if (!player.hasOwnProperty('h') || !player.hasOwnProperty('n') || !player.hasOwnProperty('id')) {
                  console.log('Player ' + i + ' is not in a recognizable format.')
                  reject(new Error('Player ' + i + ' is not in a recognizable format.'))
                  return
                }
                if (player.n === '') {
                  console.log('Player ' + i + ': name can not be blank.')
                  reject(new Error('Player ' + i + ': name can not be blank.'))
                  return
                }
                newPlayer.n = player.n
                newPlayer.h = parseInt(player.h)
                if (isNaN(newPlayer.h) || newPlayer.h < 0) {
                  console.log('Player ' + i + ': handicap (h) not a recognized value.')
                  reject(new Error('Player ' + i + ': handicap (h) not a recognized value.'))
                  return
                }
                if (player.hasOwnProperty('y')) {
                  if (player.y) {
                    newPlayer.y = true
                  } else {
                    newPlayer.y = false
                  }
                }
                if (!player.id.startsWith('p')) {
                  console.log('Player ' + i + ': id not a recognized value.')
                  reject(new Error('Player ' + i + ': id not a recognized value.'))
                  return
                }
                let oldPlayerId = player.id
                await store.dispatch('addSeasonPlayer', { seasonId, player }).then(playerId => {
                  playerIdLookup[oldPlayerId] = playerId
                })
              }
            }
            if (seasonJSON.hasOwnProperty('games')) {
              // import games, using maps of old to new player id's and schedule id's
              for (let i = 0; i < seasonJSON.games.length; i++) {
                const game = seasonJSON.games[i]
                let newGame = {}
                let oldGameId = game.id
                if (!game.hasOwnProperty('players') || !game.hasOwnProperty('d') ||
                  !game.hasOwnProperty('s') || !game.hasOwnProperty('id') ||
                  !game.hasOwnProperty('events')
                ) {
                  console.log('Game ' + i + ' is not in a recognizable format.')
                  reject(new Error('Game ' + i + ' is not in a recognizable format.'))
                  return
                }
                newGame.id = -1
                if (!game.id.startsWith('g')) {
                  console.log('Game ' + i + ': id not a recognized value.')
                  reject(new Error('Game ' + i + ': id not a recognized value.'))
                  return
                }
                let newGameDate = DateTime.fromISO(game.d)
                if (!newGameDate.isValid) {
                  console.log('Game ' + i + ': date (d) is not a recognized value.')
                  reject(new Error('Game ' + i + ': date (d) is not a recognized value.'))
                  return
                }
                newGame.d = newGameDate.toISODate()
                if (!Object.keys(scheduleIdLookup).includes(game.s)) {
                  console.log('Game ' + i + ': schedule (s) is not a recognized value.')
                  reject(new Error('Game ' + i + ': schedule (s) is not a recognized value.'))
                  return
                }
                newGame.s = scheduleIdLookup[game.s]
                if (game.players.length <= 0) {
                  console.log('Game ' + i + ': players are not in a recognized format.')
                  reject(new Error('Game ' + i + ': players are not in a recognized format.'))
                  return
                }
                newGame.players = []
                for (let j = 0; j < game.players.length; j++) {
                  const playerId = game.players[j]
                  if (!Object.keys(playerIdLookup).includes(playerId)) {
                    console.log('Game ' + i + ': player ' + j + ' is not a recognized value.')
                    reject(new Error('Game ' + i + ': player ' + j + ' is not a recognized value.'))
                    return
                  }
                  newGame.players.push(playerId)
                }
                if (game.events.length <= 0) {
                  console.log('Game ' + i + ': events are not in a recognized format.')
                  reject(new Error('Game ' + i + ': events are not in a recognized format.'))
                  return
                }
                await store.dispatch('seasonGameUpdate', { seasonId: seasonId, game: newGame, initialEvent: false }).then(async gameId => {
                  gameIdLookup[oldGameId] = gameId
                  for (let j = 0; j < game.events.length; j++) {
                    const event = game.events[j]
                    let newEvent = {}
                    if (!event.hasOwnProperty('e') || !event.hasOwnProperty('o') ||
                      !event.hasOwnProperty('t') || !event.hasOwnProperty('id')
                    ) {
                      console.log('Game ' + i + ': event ' + j + ' is not in a recognizable format.')
                      reject(new Error('Game ' + i + ': event ' + j + ' is not in a recognizable format.'))
                      return
                    }
                    if (!Object.values(gameEventTypes).includes(event.e)) {
                      console.log('Game ' + i + ': event ' + j + ' type (e) is not a recognized value.')
                      reject(new Error('Game ' + i + ': event ' + j + ' type (e) is not a recognized value.'))
                      return
                    }
                    if (event.e === gameEventTypes.heartbeat || event.e === gameEventTypes.delete) {
                      continue
                    }
                    newEvent.e = event.e
                    newEvent.o = parseInt(event.o)
                    if (isNaN(newEvent.o)) {
                      console.log('Game ' + i + ': event ' + j + ' order (o) is not a recognized value.')
                      reject(new Error('Game ' + i + ': event ' + j + ' order (o) is not a recognized value.'))
                      return
                    }
                    let eventTime = DateTime.fromISO(event.t)
                    if (!eventTime.isValid) {
                      console.log('Game ' + i + ': event ' + j + ' time (t) is not a recognized value.')
                      reject(new Error('Game ' + i + ': event ' + j + ' time (t) is not a recognized value.'))
                      return
                    }
                    newEvent.t = eventTime.toJSON()
                    switch (event.e) {
                      case gameEventTypes.knockout:
                        if (!event.hasOwnProperty('d') || !event.d.hasOwnProperty('i1') ||
                          !event.d.hasOwnProperty('i2') || !event.d.hasOwnProperty('r') ||
                          !Object.keys(playerIdLookup).includes(event.d.i1) || !Object.keys(playerIdLookup).includes(event.d.i2)
                        ) {
                          console.log('Game ' + i + ': event ' + j + ' data (d) not in recognized format.')
                          reject(new Error('Game ' + i + ': event ' + j + ' data (d) not in recognized format.'))
                          return
                        }
                        newEvent.d = {}
                        newEvent.d.i1 = playerIdLookup[event.d.i1]
                        newEvent.d.i2 = playerIdLookup[event.d.i2]
                        if (event.d.r) {
                          newEvent.d.r = true
                        } else {
                          newEvent.d.r = false
                        }
                        break
                      case gameEventTypes.topup:
                        if (!event.hasOwnProperty('d') || !event.d.hasOwnProperty('i1') ||
                          !Object.keys(playerIdLookup).includes(event.d.i1)
                        ) {
                          console.log('Game ' + i + ': event ' + j + ' data (d) not in recognized format.')
                          reject(new Error('Game ' + i + ': event ' + j + ' data (d) not in recognized format.'))
                          return
                        }
                        newEvent.d = {}
                        newEvent.d.i1 = playerIdLookup[event.d.i1]
                        break
                      default:
                        break
                    }
                    // write event to game
                    await store.dispatch('eventImport', { seasonId: seasonId, gameId: gameId, event: newEvent }).catch(err => {
                      console.log('Game ' + i + ': event ' + j + ' import failed: ' + err.message)
                      reject(new Error('Game ' + i + ': event ' + j + ' import failed: ' + err.message))
                    })
                  }
                }).catch(err => {
                  console.log('Game ' + i + ': creation failed: ' + err.message)
                  reject(new Error('Game ' + i + ': creation failed: ' + err.message))
                })
              }
            }
            if (seasonJSON.hasOwnProperty('statistics')) {
              // import statistics using map of old to new player id's
              for (let i = 0; i < seasonJSON.statistics.length; i++) {
                const stat = seasonJSON.statistics[i]
                if (!stat.hasOwnProperty('k') || !stat.hasOwnProperty('p') ||
                  !stat.hasOwnProperty('r') || !stat.hasOwnProperty('t') ||
                  !stat.hasOwnProperty('id')
                ) {
                  console.log('Statistic ' + i + ' not in recognized format.')
                  reject(new Error('Statistic ' + i + ' not in recognized format.'))
                  return
                }
                let newStat = {}
                newStat.r = parseInt(stat.r)
                if (isNaN(newStat.r) || newStat.r < 0) {
                  console.log('Statistic ' + i + ': rebuys (r) is not a recognized value.')
                  reject(new Error('Statistic ' + i + ': rebuys (r) is not a recognized value.'))
                  return
                }
                newStat.t = parseInt(stat.t)
                if (isNaN(newStat.t) || newStat.t < 0) {
                  console.log('Statistic ' + i + ': topups (t) is not a recognized value.')
                  reject(new Error('Statistic ' + i + ': topups (t) is not a recognized value.'))
                  return
                }
                if (!Object.keys(gameIdLookup).includes(stat.id)) {
                  console.log('Statistic ' + i + ': gameId (id) is not a recognized value.')
                  reject(new Error('Statistic ' + i + ': gameId (id) is not a recognized value.'))
                  return
                }
                newStat.id = gameIdLookup[stat.id]
                if (stat.k.length < 1) {
                  console.log('Statistic ' + i + ': knockouts (k) is not a recognized value.')
                  reject(new Error('Statistic ' + i + ': knockouts (k) is not a recognized value.'))
                  return
                }
                newStat.k = []
                for (let j = 0; j < stat.k.length; j++) {
                  const kO = stat.k[j]
                  if (!kO.hasOwnProperty('i1') || !kO.hasOwnProperty('i2') ||
                    !kO.hasOwnProperty('r') || !kO.hasOwnProperty('t')
                  ) {
                    console.log('Statistic ' + i + ': KO ' + j + ' is not in recognized format.')
                    reject(new Error('Statistic ' + i + ': KO ' + j + ' is not in recognized format.'))
                    return
                  }
                  let newKO = {}
                  if (!Object.keys(playerIdLookup).includes(kO.i1)) {
                    console.log('Statistic ' + i + ': KO ' + j + ' player (i1) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': KO ' + j + ' player (i1) is not a recognized value.'))
                    return
                  }
                  newKO.i1 = kO.i1
                  if (!Object.keys(playerIdLookup).includes(kO.i2)) {
                    console.log('Statistic ' + i + ': KO ' + j + ' player (i2) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': KO ' + j + ' player (i2) is not a recognized value.'))
                    return
                  }
                  newKO.i2 = kO.i2
                  if (kO.r) {
                    newKO.r = true
                  } else {
                    newKO.r = false
                  }
                  let kOTime = DateTime.fromISO(kO.t)
                  if (!kOTime.isValid) {
                    console.log('Statistic ' + i + ': KO ' + j + ' time (t) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': KO ' + j + ' time (t) is not a recognized value.'))
                    return
                  }
                  newKO.t = kOTime.toJSON()
                  newStat.k.push(newKO)
                }
                if (Object.keys(stat.p).length < 2) {
                  console.log('Statistic ' + i + ': players (p) is not a recognized value.')
                  reject(new Error('Statistic ' + i + ': players (p) is not a recognized value.'))
                  return
                }
                newStat.p = {}
                for (let j = 0; j < Object.keys(stat.p).length; j++) {
                  const playerId = Object.keys(stat.p)[j]
                  const playerStat = stat.p[playerId]
                  if (!Object.keys(playerIdLookup).includes(playerId) || !playerStat.hasOwnProperty('f') ||
                    !playerStat.hasOwnProperty('k') || !playerStat.hasOwnProperty('p') ||
                    !playerStat.hasOwnProperty('r') || !playerStat.hasOwnProperty('t')
                  ) {
                    console.log('Statistic ' + i + ': player stat ' + j + ' is not in recognized format.')
                    reject(new Error('Statistic ' + i + ': player stat ' + j + ' is not in recognized format.'))
                    return
                  }
                  let newPlayerStat = {}
                  newPlayerStat.f = parseInt(playerStat.f)
                  if (isNaN(newPlayerStat.f) || newPlayerStat.f < 0) {
                    console.log('Statistic ' + i + ': player stat ' + j + ' finish (f) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': player stat ' + j + ' finish (f) is not a recognized value.'))
                    return
                  }
                  newPlayerStat.k = parseInt(playerStat.k)
                  if (isNaN(newPlayerStat.k) || newPlayerStat.k < 0) {
                    console.log('Statistic ' + i + ': player stat ' + j + ' knockouts (k) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': player stat ' + j + ' knockouts (k) is not a recognized value.'))
                    return
                  }
                  newPlayerStat.p = parseInt(playerStat.p)
                  if (isNaN(newPlayerStat.p) || newPlayerStat.p < 0) {
                    console.log('Statistic ' + i + ': player stat ' + j + ' points (p) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': player stat ' + j + ' points (p) is not a recognized value.'))
                    return
                  }
                  newPlayerStat.r = parseInt(playerStat.r)
                  if (isNaN(newPlayerStat.r) || newPlayerStat.r < 0) {
                    console.log('Statistic ' + i + ': player stat ' + j + ' rebuys (r) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': player stat ' + j + ' rebuys (r) is not a recognized value.'))
                    return
                  }
                  newPlayerStat.t = parseInt(playerStat.t)
                  if (isNaN(newPlayerStat.t) || newPlayerStat.t < 0) {
                    console.log('Statistic ' + i + ': player stat ' + j + ' topups (t) is not a recognized value.')
                    reject(new Error('Statistic ' + i + ': player stat ' + j + ' topups (t) is not a recognized value.'))
                    return
                  }
                  newStat.p[playerIdLookup[playerId]] = newPlayerStat
                }
                await database.game.createStat(state.currentUser.uid, seasonId, gameIdLookup[stat.id], newStat).catch(err => {
                  console.log('Statistic ' + i + ' import failed.' + err.message)
                  reject(new Error('Statistic ' + i + ' import failed.' + err.message))
                })
              }
            }
            resolve(seasonId)
          }).catch(function (err) {
            reject(new Error('Import season failed: ' + err.message))
          })
        } else {
          console.log('Season not in recognized format.')
          reject(new Error('Season not in recognized format.'))
        }
      })
    },
    seasonActivate ({commit, state}, { seasonId, shared = false }) {
      return new Promise((resolve, reject) => {
        if (seasonId < 0) {
          store.dispatch('stopSnapshot', 'seasonPlayers')
          store.dispatch('stopSnapshot', 'seasonSchedules')
          store.dispatch('stopSnapshot', 'seasonGames')
          store.dispatch('stopSnapshot', 'seasonStats')
          commit('setActiveSeasonId', { seasonId: seasonId })
          resolve()
        } else {
          commit('setActiveSeasonId', { seasonId: seasonId, shared: shared })
          store.dispatch('startSnapshot', { 'collection': 'seasonPlayers', 'name': 'seasonPlayers' })
          store.dispatch('startSnapshot', { 'collection': 'seasonSchedules', 'name': 'seasonSchedules' })
          store.dispatch('startSnapshot', { 'collection': 'seasonGames', 'name': 'seasonGames' })
          store.dispatch('startSnapshot', { 'collection': 'seasonStats', 'name': 'seasonStats' })
          resolve()
        }
      })
    },
    async gameActivate ({commit, state}, gameId) {
      commit('stopGameTimerUpdateTimer')
      commit('clearGameTimer')
      await store.dispatch('stopSnapshot', 'gameTimerEvents')
      await store.dispatch('stopSnapshot', 'gameTimerGame')
      commit('setActiveGameId', gameId)
      store.dispatch('startSnapshot', {'collection': 'gameTimerEvents', 'name': 'gameTimerEvents'})
      store.dispatch('startSnapshot', {'collection': 'gameTimerGame', 'name': 'gameTimerGame'})
    },
    async clearActiveGame ({commit, state}) {
      commit('clearGameTimer')
      commit('stopGameTimerUpdateTimer')
      commit('setActiveGameId', -1)
      await store.dispatch('stopSnapshot', 'gameTimerEvents')
      await store.dispatch('stopSnapshot', 'gameTimerGame')
    },
    setGameTimerGame ({commit, state}, game) {
      commit('setGameTimerGame', game)
    },
    gameEventAdded ({commit, state, getters}, gameEvent) {
      return new Promise((resolve, reject) => {
        let seasonId = gameEvent.seasonId
        let gameId = gameEvent.gameId
        switch (gameEvent.doc.e) {
          case gameEventTypes.created:
            let maxPlayTime = Duration.fromMillis(0)
            database.season.getGame(state.currentUser.uid, seasonId, gameId).then(gameDoc => {
              commit('setGameTimerGame', gameDoc)
              let scheduleId = state.gameTimerGame.s
              database.season.getSchedule(state.currentUser.uid, seasonId, scheduleId).then(scheduleDoc => {
                commit('setGameTimerSchedule', scheduleDoc)
                database.season.getScheduleLevels(state.currentUser.uid, seasonId, scheduleId).then(async levels => {
                  for (let i = 0; i < levels.length; i++) {
                    const level = levels[i]
                    maxPlayTime = maxPlayTime.plus(level.m * 60000)
                  }
                  commit('setGameTimerLevels', levels)
                  commit('updateGameTimer', {maxPlayTime: maxPlayTime})
                  let players = []
                  for (let i = 0; i < state.gameTimerGame.players.length; i++) {
                    const playerId = state.gameTimerGame.players[i]
                    await database.season.getPlayer(state.currentUser.uid, seasonId, playerId).then(playerDoc => {
                      let player = {}
                      player.n = playerDoc.n
                      player.id = playerId
                      player.stillIn = true
                      player.rebuys = 0
                      player.topups = 0
                      player.points = 0
                      player.KOs = 0
                      player.place = 0
                      players.push(player)
                    }).catch(function (err) {
                      reject(new Error(err.message))
                    })
                  }
                  players.sort(function (a, b) {
                    var nameA = a.n.toUpperCase()
                    var nameB = b.n.toUpperCase()

                    if (nameA < nameB) {
                      return -1
                    }
                    if (nameA > nameB) {
                      return 1
                    }
                    return 0
                  })
                  commit('setGameTimerPlayers', players)
                  commit('setTotalPotandChips')
                  commit('setGameTimerState', gameEvent.doc)
                  commit('addGameTimerEvent', gameEvent.doc)
                  resolve()
                }).catch(err => {
                  reject(new Error(err.message))
                })
              }).catch(err => {
                reject(new Error(err.message))
              })
            }).catch(err => {
              reject(new Error(err.message))
            })
            break
          case gameEventTypes.play:
            commit('setGameTimerState', gameEvent.doc)
            commit('updateGameTimerUpdateTimer', setInterval(function () {
              store.dispatch('refreshGameTimer')
            }, 500))
            commit('addGameTimerEvent', gameEvent.doc)
            resolve()
            break
          case gameEventTypes.pause:
            commit('stopGameTimerUpdateTimer')
            commit('setGameTimerState', gameEvent.doc)
            commit('addGameTimerEvent', gameEvent.doc)
            resolve()
            break
          case gameEventTypes.previous:
          case gameEventTypes.next:
            commit('setGameTimerState', gameEvent.doc)
            commit('addGameTimerEvent', gameEvent.doc)
            resolve()
            break
          case gameEventTypes.knockout:
            commit('knockoutPlayer', gameEvent.doc)
            commit('addGameTimerEvent', gameEvent.doc)
            resolve()
            break
          case gameEventTypes.topup:
            commit('topupPlayer', gameEvent.doc)
            commit('addGameTimerEvent', gameEvent.doc)
            resolve()
            break
          case gameEventTypes.finished:
            commit('setGameTimerState', gameEvent.doc)
            commit('addGameTimerEvent', gameEvent.doc)
            resolve()
            break
          case gameEventTypes.rollover:
            commit('setGameTimerRolloverSent', false)
            resolve()
            break
          case gameEventTypes.delete:
            let array = state.gameTimerEvents
            for (var i = 0; i < array.length; i++) {
              if (array[i]['id'] === gameEvent.doc.d.i1) {
                commit('stopGameTimerUpdateTimer')
                commit('resetGameTimerEvents')
              }
            }
            resolve()
            break
          default:
            resolve()
            break
        }
      })
    },
    refreshGameTimer ({state, commit, getters}) {
      if (!state.loading.eventTimer &&
        !state.loading.eventTimerResetPending &&
        state.gameTimerGame.hasOwnProperty('schedule')
      ) {
        let gameTimer = {}
        let levels = state.gameTimerGame.schedule.levels

        if (state.gameTimer.hasOwnProperty('state')) {
          let timePassedDuration = Duration.fromMillis(0)
          let durationSinceEvent = DateTime.local().diff(state.gameTimer.stateTime)
          let index = 0
          let playButton = true
          let rwdButton = false
          let fwdButton = true

          switch (state.gameTimer.state) {
            case gameEventTypes.created:
              playButton = true
              rwdButton = false
              fwdButton = true
              break
            case gameEventTypes.play:
              let playTime = state.gameTimer.playTime
              timePassedDuration = durationSinceEvent.plus(playTime)
              playButton = false
              rwdButton = true
              fwdButton = true
              break
            case gameEventTypes.pause:
            case gameEventTypes.finished:
            case gameEventTypes.previous:
            case gameEventTypes.next:
              timePassedDuration = state.gameTimer.playTime
              playButton = true
              rwdButton = (timePassedDuration.as('milliseconds') > 0)
              break
            default:
              break
          }
          gameTimer.duringFirstBreak = false
          gameTimer.duringSecondBreak = false
          gameTimer.firstBreakFinished = false
          gameTimer.secondBreakFinished = false
          while (index < levels.length && timePassedDuration.as('minutes') >= levels[index].m) {
            timePassedDuration = timePassedDuration.minus(Duration.fromObject({minutes: levels[index].m}))
            index += 1
            if (index < levels.length && !state.gameTimer.isFinished) {
              if (levels[index].t === blindLevelTypes.break) {
                if (!gameTimer.firstBreakFinished) {
                  gameTimer.duringFirstBreak = true
                } else if (!gameTimer.secondBreakFinished) {
                  gameTimer.duringSecondBreak = true
                }
              } else if (gameTimer.duringFirstBreak) {
                gameTimer.duringFirstBreak = false
                gameTimer.firstBreakFinished = true
              } else if (gameTimer.duringSecondBreak) {
                gameTimer.duringSecondBreak = false
                gameTimer.secondBreakFinished = true
              }
            }
          }
          if (index === 0) {
            gameTimer.isFirstLevel = true
          } else {
            gameTimer.isFirstLevel = false
          }

          if (index === levels.length - 1) {
            gameTimer.isLastLevel = true
            fwdButton = false
          } else {
            gameTimer.isLastLevel = false
            fwdButton = true
          }

          if (index < levels.length) {
            let timeRemaining = Duration.fromObject({minutes: levels[index].m}).minus(timePassedDuration)
            gameTimer.timeRemaining = timeRemaining.toFormat('mm:ss')
            gameTimer.blindCurrent = getters.blindByLevel(levels[index])
            gameTimer.blindCurrentIndex = index
            if (index > 0) {
              gameTimer.blindPrevious = getters.blindByLevel(levels[index - 1])
            } else {
              gameTimer.blindPrevious = 'Start'
            }
            if (index === levels.length - 1) {
              gameTimer.blindNext = 'Finished'
            } else {
              gameTimer.blindNext = getters.blindByLevel(levels[index + 1])
            }
            if (levels[index].t === blindLevelTypes.break) {
              gameTimer.blindMessage = 'Color Up from ' + levels[index].cf + ' to ' + levels[index].ct + '.'
            } else {
              gameTimer.blindMessage = null
            }
          } else {
            gameTimer.timeRemaining = '00:00'
            gameTimer.blindCurrentIndex = -1
            gameTimer.blindCurrent = 'Finished'
            gameTimer.blindNext = ''
            gameTimer.blindPrevious = levels[index - 1].s + ' / ' + levels[index - 1].b
            gameTimer.blindMessage = 'Finished all blind levels'
            gameTimer.isFinished = true
            if (!state.gameTimer.isFinished) {
              commit('setGameTimerFinished', true)
              store.dispatch('gameEventAdd', { type: gameEventTypes.finished, gameId: state.activeGameId, seasonId: state.activeSeasonId, broadcast: state.gameTimerGame.b })
            }
          }

          let currentSeason = getters.currentSeason
          if (state.gameTimer.isFinished || gameTimer.isFinished) {
            gameTimer.blindMessage = 'Finished'
          } else {
            switch (currentSeason.r) {
              case rebuysAllowed.always:
                gameTimer.canRebuy = true
                break
              case rebuysAllowed.never:
                gameTimer.canRebuy = false
                break
              case rebuysAllowed.untilFirstBreakEnd:
                gameTimer.canRebuy = !gameTimer.firstBreakFinished
                break
              case rebuysAllowed.untilSecondBreakEnd:
                gameTimer.canRebuy = !gameTimer.secondBreakFinished
                break
              default:
                gameTimer.canRebuy = false
                break
            }
            switch (currentSeason.t) {
              case topupsAllowed.always:
                gameTimer.canTopup = true
                break
              case topupsAllowed.duringFirstAndSecondBreak:
                gameTimer.canTopup = (gameTimer.duringFirstBreak || gameTimer.duringSecondBreak)
                break
              case topupsAllowed.duringFirstBreak:
                gameTimer.canTopup = gameTimer.duringFirstBreak
                break
              case topupsAllowed.never:
                gameTimer.canTopup = false
                break
              case topupsAllowed.untilFirstBreakEnd:
                gameTimer.canTopup = !gameTimer.firstBreakFinished
                break
              case topupsAllowed.untilSecondBreakEnd:
                gameTimer.canTopup = !gameTimer.secondBreakFinished
                break
              default:
                gameTimer.canTopup = false
                break
            }
          }
          gameTimer.payouts = []
          switch (currentSeason.gpo) {
            case 1:
              gameTimer.payouts.push(state.gameTimer.totalPot)
              break
            case 2:
              gameTimer.payouts.push(Math.round(state.gameTimer.totalPot * 0.6))
              gameTimer.payouts.push(state.gameTimer.totalPot - gameTimer.payouts[0])
              break
            case 3:
              gameTimer.payouts.push(Math.round(state.gameTimer.totalPot * 0.5))
              gameTimer.payouts.push(Math.round(state.gameTimer.totalPot * 0.3))
              gameTimer.payouts.push(state.gameTimer.totalPot - gameTimer.payouts[0] - gameTimer.payouts[1])
              break
          }
          gameTimer.totalChipsFormatted = numberWithCommas(state.gameTimer.totalChips)
          gameTimer.averageChips = numberWithCommas(Math.round(state.gameTimer.totalChips / (state.gameTimerPlayers.length - state.gameTimer.playersKOd)))
          gameTimer.playButton = playButton
          gameTimer.fwdButton = fwdButton
          gameTimer.rwdButton = rwdButton
          commit('updateGameTimer', gameTimer)
          switch (state.gameTimer.timeRemaining) {
            case '00:05':
              if (state.gameTimer.state === gameEventTypes.play && !state.gameTimerWarningPlayed.five) {
                commit('setGameTimerWarningPlayed', {five: true})
                playSound(sounds.fiveSecondWarningBeep).then(function () {
                  playSound(sounds.threeSecondWarningBeep).then(function () {
                    playSound(sounds.oneSecondWarningBeep)
                  })
                })
              }
              break
            case '00:00':
              if (!state.gameTimer.rolloverSent && !state.gameTimer.isFinished && !gameTimer.isFinished) {
                commit('setGameTimerRolloverSent', true)
                setTimeout(() => { store.dispatch('gameEventAdd', { type: gameEventTypes.rollover, gameId: state.activeGameId, seasonId: state.activeSeasonId, broadcast: state.gameTimerGame.b }) }, 1000)
              }
              break
            default:
              if (state.gameTimerWarningPlayed.five) {
                commit('setGameTimerWarningPlayed', {five: false})
              }
              if (state.gameTimerWarningPlayed.three) {
                commit('setGameTimerWarningPlayed', {three: false})
              }
              if (state.gameTimerWarningPlayed.one) {
                commit('setGameTimerWarningPlayed', {one: false})
              }
              break
          }
        }
      }
    },
    backupSeason ({state}, seasonId) {
      return new Promise((resolve, reject) => {
        database.season.jsonify(seasonId).then(seasonJSON => {
          resolve(seasonJSON)
        }).catch(function (err) {
          reject(new Error('Season backup failed: ' + err.message))
        })
      })
    },
    getSeasonSchedules ({state}, seasonId) {
      return new Promise((resolve, reject) => {
        let scheduleList = []
        database.season.getScheduleList(state.currentUser.uid, seasonId).then(schedules => {
          for (let i = 0; i < schedules.length; i++) {
            const schedule = schedules[i]
            let reducedSchedule = {
              n: schedule.n,
              id: schedule.id
            }
            scheduleList.push(reducedSchedule)
          }
          resolve(scheduleList)
        })
      })
    },
    getSchedule ({state}, {seasonId, scheduleId}) {
      return new Promise((resolve, reject) => {
        database.season.getSchedule(state.currentUser.uid, seasonId, scheduleId, true).then(schedule => {
          schedule.id = scheduleId
          resolve(schedule)
        }).catch(function (err) {
          reject(new Error(err.message))
        })
      })
    },
    importNewSchedule ({state}, {seasonId, schedule}) {
      return new Promise((resolve, reject) => {
        let levels = JSON.parse(JSON.stringify(schedule.levels))
        delete schedule['levels']
        store.dispatch('seasonIncreaseMaxId', {seasonId: seasonId, type: seasonObjectTypes.schedule}).then(newId => {
          let scheduleId = newId
          database.season.updateSchedule(state.currentUser.uid, seasonId, scheduleId, schedule).then(() => {
            database.season.createScheduleLevels(state.currentUser.uid, seasonId, scheduleId, levels).then(() => {
              resolve(scheduleId)
            }).catch(function (err) {
              reject(new Error(err.message))
            })
          }).catch(function (err) {
            reject(new Error(err.message))
          })
        }).catch(function (err) {
          reject(new Error(err.message))
        })
      })
    },
    displayMessage ({commit}, message) {
      if (message.trim() !== '') commit('addNotification', { message: message, duration: 5000 })
    },
    displayError ({commit}, message) {
      if (message.trim() !== '') commit('addNotification', { message: message, duration: 5000, isError: true })
    },
    removeNotification ({commit, state}) {
      if (state.notify.length > 0) commit('removeNotification')
    },
    uploadNewAvatar ({state}, blob) {
      return new Promise((resolve, reject) => {
        let uploadTime = DateTime.local().plus(state.serverTimeOffset).toMillis()
        let storageRef = storage.ref(auth.currentUser.uid + '/profilePicture/profile' + uploadTime.toString() + '.jpg')
        let uploadTask = storageRef.put(blob)

        uploadTask.on('state_changed', function (shapshot) {
          return true
        }, function (error) {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break
            case 'storage/canceled':
              // User canceled the upload
              break
            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break
            default:
              // Unhandled error occurred, inspect error.serverResponse
              break
          }
          reject(new Error(error.code))
        }, function () {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            resolve(downloadURL)
          })
        })
      })
    },
    isNameInUse ({state}, newName) {
      return new Promise((resolve, reject) => {
        database.user.isNameInUse(newName, auth.currentUser.uid).then(isUsed => {
          if (isUsed) {
            resolve(isInUse.yes)
          } else {
            resolve(isInUse.no)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateUserName ({state, commit}, newName) {
      return new Promise((resolve, reject) => {
        database.user.isNameInUse(newName, auth.currentUser.uid).then(isUsed => {
          if (isUsed) {
            let newError = Error('updateUserName: Username is in use.')
            console.log(newError.message)
            reject(newError)
          } else {
            let userUpdate = {}
            userUpdate.name = newName
            if (state.currentUser.new) {
              userUpdate.new = fieldValue.delete()
            }
            database.user.update(auth.currentUser.uid, userUpdate).then(() => {
              auth.currentUser.updateProfile({ displayName: userUpdate.name }).then(() => {
                resolve()
              }).catch(err => {
                console.log('Error updating Firebase profile: ' + err.message)
                reject(new Error('Error updating Firebase profile: ' + err.message))
              })
              // resolve()
            }).catch(err => {
              reject(new Error(err.message))
            })
          }
        }).catch(err => {
          reject(new Error(err.message))
        })
      })
    },
    updateProfilePhoto ({state, commit}, newURL) {
      return new Promise((resolve, reject) => {
        let userUpdate = {
          photoURL: newURL
        }
        database.user.update(auth.currentUser.uid, userUpdate).then(() => {
          auth.currentUser.updateProfile({ photoURL: newURL }).then(() => {
            resolve()
          }).catch(err => {
            console.log(err.message)
            reject(new Error('Error updating profile: ' + err.message))
          })
        }).catch(err => {
          reject(new Error(err.message))
        })
      })
    },
    updateEmail ({state, commit}, newEmail) {
      return new Promise((resolve, reject) => {
        auth.currentUser.updateEmail(newEmail).then(() => {
          resolve()
        }).catch((err) => {
          console.log('Error updating email: ' + err.message)
          reject(new Error('Error updating email: ' + err.message))
        })
      })
    },
    updatePassword ({state, commit}, newPassword) {
      return new Promise((resolve, reject) => {
        auth.currentUser.updatePassword(newPassword).then(() => {
          resolve()
        }).catch((err) => {
          console.log('Error updating password: ' + err.message)
          reject(new Error('Error updating password: ' + err.message))
        })
      })
    },
    refreshUser ({state, commit}) {
      return new Promise((resolve, reject) => {
        let user = auth.currentUser
        database.user.get(user.uid).then(async legacyUser => {
          let userUpdate = {}
          if (!legacyUser.hasOwnProperty('name') || legacyUser.name !== user.displayName) {
            userUpdate.new = true
            userUpdate.name = user.displayName
          }
          if (!legacyUser.hasOwnProperty('photoURL') || legacyUser.photoURL !== user.photoURL) {
            userUpdate.photoURL = user.photoURL
          }
          if (userUpdate !== {}) {
            await database.user.update(user.uid, userUpdate).catch(err => {
              let newError = Error('Legacy profile error: ' + err.message)
              reject(newError)
            })
          }
          store.commit('refreshCurrentUser')
          if (legacyUser.hasOwnProperty('new') || userUpdate.hasOwnProperty('new')) {
            commit('setNewUser')
          }
          resolve()
        }).catch(err => {
          reject(Error('Error initializing user data:' + err.message))
        })
      })
    }
  }
})

export default store
